export interface IDateObject {
	day: string;
	month: string;
	year: string;
}

export const DefaultDateObject = {
	day: '',
	month: '',
	year: '',
};

export const convertToJsDate = (date: IDateObject) =>
	new Date(parseInt(date.year, 10), parseInt(date.month, 10) - 1, parseInt(date.day, 10));

export const setNextValidFutureDateTime = (baseDate: Date, intervalMinutes: number) => {
	const date = new Date(baseDate);
	date.setMinutes(date.getMinutes() + intervalMinutes);
	// Round up to the next 15-min interval (15, 30, 45, 0)
	const minutes = date.getMinutes();
	const remainder = minutes % 15;
	if (remainder !== 0) {
		date.setMinutes(minutes + (15 - remainder), 0, 0);
	} else {
		// If already on an interval, move to the next one
		date.setMinutes(minutes + 15, 0, 0);
	}

	const hour = date.getHours().toString().padStart(2, '0');
	const minute = date.getMinutes().toString().padStart(2, '0');

	return { date, hour, minute };
};
